import { SBImage } from '@/components/ImageService/SBImage';
import { Mindentity } from '@/components/Mindentity/Mindentity';
import { Typography } from '@/shared';
import { useMicrocopy } from '@/shared/providers/Microcopy/MicrocopyHook';
import { ArticleStoryblok } from '@/shared/types/storyblok/storyblok-types';
import Link from 'next/link';
import styles from './FeaturedBlog.module.scss';

const FeaturedBlog = ({ featuredBlog, isMobile }: { featuredBlog: ArticleStoryblok; isMobile: boolean }) => {
    const { customTitle, author } = featuredBlog?.content || {};
    const authorBlog = author?.content || {};
    let formattedTitle = customTitle?.replace(/\*/g, '') ?? '';
    formattedTitle = formattedTitle?.replace('&shy;', '');
    const { microcopy } = useMicrocopy();

    return (
        <div className={styles.blogBox}>
            <Link
                scroll={true}
                className={styles.link}
                style={{ height: '100%' }}
      
                href={featuredBlog.full_slug}
            >
                <div>
                    <Typography.Small className={styles.infoStyle}>Expertise</Typography.Small>
                    <Typography.ArticleQuote className={styles.titleBlog}>{formattedTitle}</Typography.ArticleQuote>
                </div>
                <div className={styles.articleBy}>
                    {authorBlog?.portrait?.filename && !isMobile && (
                        <Mindentity isDark={true} name={authorBlog.fullname} color={author?.content?.mind_color?.color}>
                            <SBImage image={authorBlog?.portrait} width={96} height={96} />
                        </Mindentity>
                    )}
                    {authorBlog?.portrait?.filename && isMobile && (
                        <SBImage image={authorBlog?.portrait} width={96} height={96} />
                    )}
                    <div className={styles.authorInfo}>
                        {authorBlog?.fullname && (
                            <Typography.Small className={styles.infoStyle}>
                                {`${microcopy.articleBy} ${authorBlog?.fullname}`}
                            </Typography.Small>
                        )}
                        <Typography.Small className={styles.infoStyle}>{authorBlog?.role}</Typography.Small>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default FeaturedBlog;
